export const KAYENTA_CANARY = 'kayentaCanary';
export const RUN_CANARY = 'runCanary';
export const WAIT = 'wait';
export const CREATE_SERVER_GROUP = 'createServerGroup';
export const DEPLOY_CANARY_SERVER_GROUPS = 'deployCanaryServerGroups';
